import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

// JS-1871 (Self Service 2a/2b/2c) — Angular wrapper for /client/self-service/* endpoints.
@Injectable({ providedIn: 'root' })
export class ClientSelfServiceService {
  constructor(private http: HttpClient) {}

  // Paginated list of active employees in this client's pool + filter/search/sort.
  employees(payload: {
    filter: any;
    search?: string;
    page?: number;
    per_page?: number;
    order_by?: string;
    order_asc?: boolean;
  }) {
    return this.http.post<any>(`${environment.apiUrl}/client/self-service/employees`, payload);
  }

  saveAsList(payload: { name: string; filter: any; search?: string; deselected?: number[] }) {
    return this.http.post<any>(`${environment.apiUrl}/client/self-service/employees/save-as-list`, payload);
  }

  listGroups(clientId: number | null = null) {
    // JS-1871: agency users reviewing a self-service project pass client_id explicitly so the
    // server can resolve the pool without relying on the auth user's client_id.
    const q = clientId ? `?client_id=${clientId}` : '';
    return this.http.get<any>(`${environment.apiUrl}/client/self-service/employee-groups${q}`);
  }

  createGroup(name: string) {
    return this.http.post<any>(`${environment.apiUrl}/client/self-service/employee-groups`, { name });
  }

  renameGroup(id: number, name: string) {
    return this.http.put<any>(`${environment.apiUrl}/client/self-service/employee-groups/${id}`, { name });
  }

  deleteGroup(id: number) {
    return this.http.delete<any>(`${environment.apiUrl}/client/self-service/employee-groups/${id}`);
  }

  checkExists(name: string) {
    const q = encodeURIComponent(name);
    return this.http.get<any>(`${environment.apiUrl}/client/self-service/employee-groups/list-exists?name=${q}`);
  }

  addMember(groupId: number, employeeId: number) {
    return this.http.post<any>(`${environment.apiUrl}/client/self-service/employee-groups/add-member`, {
      group_id: groupId,
      employee_id: employeeId,
    });
  }

  removeMembers(groupIds: number[], employeeIds: number[]) {
    return this.http.post<any>(`${environment.apiUrl}/client/self-service/employee-groups/remove-members`, {
      group_ids: groupIds,
      employee_ids: employeeIds,
    });
  }

  getNotInList(groupId: number, search = '') {
    const q = search ? `?q=${encodeURIComponent(search)}` : '';
    return this.http.get<any>(`${environment.apiUrl}/client/self-service/employee-groups/${groupId}/not-in-list${q}`);
  }

  // JS-1871 — client-scoped profile views
  getEmployeeClientRating(employeeId: number) {
    return this.http.get<any>(`${environment.apiUrl}/client/self-service/employees/${employeeId}/rating`);
  }

  getEmployeeInternalRemark(employeeId: number) {
    return this.http.get<any>(`${environment.apiUrl}/client/self-service/employees/${employeeId}/internal-remark`);
  }

  updateEmployeeInternalRemark(employeeId: number, remark: string) {
    return this.http.put<any>(`${environment.apiUrl}/client/self-service/employees/${employeeId}/internal-remark`, { remark });
  }

  getEmployeeClientLists(employeeId: number) {
    return this.http.get<any>(`${environment.apiUrl}/client/self-service/employees/${employeeId}/lists`);
  }

  syncEmployeeClientLists(employeeId: number, groupIds: number[]) {
    return this.http.put<any>(`${environment.apiUrl}/client/self-service/employees/${employeeId}/lists`, { group_ids: groupIds });
  }
}
